module.exports = __webpack_public_path__ + "img/expostyle_0905_grey_pantonecool_grey8c.0230893d.jpg";